import React from 'react';
import { getLoggedUser } from '../../../../state/user';
import i18n from '../../../../i18n';
import { getOrganizationList } from '../../../../models/organization';
import { getGroupsList } from '../../../../models/groups';
import { HomeBanner } from '../../../home/homeBanner';
import { SideBar } from '../../components/Sidebar/Sidebar';
import FilterSection from '../../../common/Filter';
import Dropdown from '../../../common/DropDown';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import Select from 'react-select';
import { getFinalReport } from '../../../../models/auctions';
import { Award, Download, FileMinus, FileSpreadsheet, Medal, Printer, Trophy } from 'lucide-react';
import '../../../../styles/components/bidder-details-table.scss';
import { apiUrl } from '../../../../constants/global';
import NewDropdown from '../../../common/NewDropDown';
import axios from 'axios';

const user = getLoggedUser();

export class FinalReportNew extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        client: '',
        group: '',
      },
      clients: [],
      groups: [],
      auctions: [],
      is_loading: false,
      export_loading: false,
      limit: 15,
      page: 1,
      showModal: false,
      action: null,
      columns: [
        {
          name: '', // Empty name for the expand column
          selector: () => null, // Empty selector for expand column
          sortable: false,
          width: '30px', // Fixed width for expand button
          allowOverflow: true,
          button: true,
        },
        { name: 'Auction ID', selector: (row) => row.id, sortable: true },
        { name: 'Title', selector: (row) => row.title, sortable: true },
        { name: 'Location', selector: (row) => row.location, sortable: true },
        { name: 'Start Date', selector: (row) => new Date(row.start_date).toLocaleString() },
        { name: 'End Date', selector: (row) => new Date(row.end_date).toLocaleString() },
      ],
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      client: params.get('client') || '',
      group: params.get('group') || '',
    };
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, page, limit }, () => {
      this.getAllClients?.().then(() => {
        if (this.state.search.client) {
          this.getAllGroups();
        }
        if (this.state.search.client && this.state.search.group) {
          this.getAuctionByGroupIds();
        }
      });
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getAuctionByGroupIds() {
    this.setState({ is_loading: true });
    let { limit, page } = this.state;
    let { group, client } = this.state.search;

    if (!client && !group) {
      this.setState({ is_loading: false, auctions: [], total: 0 });
      return;
    }
    const q = {
      page: page,
      limit: limit,
    };
    if (group) q.group = group;
    if (client) q.client = client;

    // Update URL
    this.updateUrlQuery(q);

    let response = await getFinalReport(q);
    if (response.success) {
      let auctions = response.data;
      let { total } = response.meta;
      this.setState({
        auctions,
        total,
        is_loading: false,
      });
    }
    this.setState({ is_loading: false });
  }
  async getAllClients() {
    const response = await getOrganizationList();
    let clients = response.data;
    this.setState({ clients });
  }

  async getAllGroups() {
    this.setState({ group_loading: true });
    let { client } = this.state.search;
    let q = client ? `organization=${client}` : '';
    const response = await getGroupsList(q);
    if (response.success) {
      let data = response.data;

      const groups = data.map((item) => {
        return {
          value: item.id,
          label: item.group_name,
        };
      });
      this.setState({ groups: groups });
      this.setState({ group_loading: false });
    } else {
      this.setState({ group_loading: false });
    }
  }

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = { ...prevState.search, [name]: value };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client') {
          this.getAllGroups();
        }
      }
    );
  };

  handleSearch = () => {
    let { group, client } = this.state.search;

    if (!client && (!group || group.length === 0)) {
      this.setState({ is_loading: false, auctions: [], total: 0 });
      return;
    }
    if (client && group) {
      this.getAuctionByGroupIds();
    }
  };

  handleClear = () => {
    const defaultSearch = {
      client: '',
      group: '',
    };

    this.setState({ search: defaultSearch, groups: [], page: 1 }, () => {
      this.updateUrlQuery({ page: 1, limit: this.state.limit });
      this.getAuctionByGroupIds();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getAuctionByGroupIds();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getAuctionByGroupIds();
    });
  };
  handleDownload = async (fileType) => {
    this.setState({ export_loading: true });
    try {
      const query = new URLSearchParams({
        groupId: this.state.search.group,
        fileType,
      }).toString();

      const response = await axios.get(`${apiUrl}final-report/export?${query}`, {
        responseType: 'blob', // ✅ important for PDF/Excel binary data
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });

      const blob = new Blob([response.data], {
        type:
          fileType === 'pdf'
            ? 'application/pdf'
            : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);

      if (fileType === 'pdf') {
        // Open in new tab instead of showing raw text
        const contentDisposition = response.headers['content-disposition'];
        const filename = contentDisposition
          ? contentDisposition.split('filename=')[1].replace(/"/g, '')
          : `final_report_${Date.now()}.pdf`;

        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        // Excel → force download
        const contentDisposition = response.headers['content-disposition'];
        const filename = contentDisposition
          ? contentDisposition.split('filename=')[1].replace(/"/g, '')
          : `final_report_${Date.now()}.xlsx`;

        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export error:', error);
    } finally {
      this.setState({ export_loading: false });
    }
  };
  render() {
    const { clients, groups, group_loading, export_loading } = this.state;

    return (
      <React.Fragment>
        <HomeBanner />
        <section className="mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <h3 className="card-title">{i18n.t('final_report')}</h3>

                    {this.state.search.group && (
                      <div className="export">
                        <NewDropdown
                          label="Export"
                          loading={export_loading}
                          icon={Download}
                          items={[
                            {
                              label: 'PDF',
                              icon: Printer,
                              onClick: () => this.handleDownload('pdf'),
                            },
                            {
                              label: 'Excel',
                              icon: FileSpreadsheet,
                              onClick: () => this.handleDownload('excel'),
                            },
                          ]}
                        />
                      </div>
                    )}
                    <FilterSection
                      loading={this.state.is_loading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      {/* Client Dropdown */}
                      <Dropdown
                        name="client"
                        value={this.state.search.client}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('client_name')}
                        options={clients.map((c) => ({ value: c.id, label: c.organization_name }))}
                      />

                      {/* Group Dropdown */}

                      <Select
                        // isMulti
                        options={groups} // [{ value: 1, label: 'Group 1' }, ...]
                        value={groups.find((c) => c.value === this.state.search.group) || null}
                        onChange={(selectedOption) => {
                          this.setState((prevState) => ({
                            search: {
                              ...prevState.search,
                              group: selectedOption ? selectedOption.value : null,
                            },
                          }));
                        }}
                        name="group"
                        styles={selectStyles}
                        menuPlacement="auto"
                        menuPortalTarget={document.body}
                        placeholder={
                          group_loading ? i18n.t('loading') + '...' : i18n.t('auction_group')
                        }
                        isDisabled={group_loading}
                      />
                    </FilterSection>

                    <div className="Data-Listing">
                      {this.state.is_loading ? (
                        <TableSkeleton columns={6} rows={10} />
                      ) : this.state.auctions.length ? (
                        <DataTable
                          title=""
                          columns={this.state.columns}
                          data={this.state.auctions}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                          onChangePage={this.onChangePage}
                          expandableRows
                          expandableRowsComponent={({ data }) => (
                            <BiddersTable data={data.bidders} />
                          )}
                        />
                      ) : (
                        <NoData
                          message="No Final Report Available"
                          // actionText="Refresh"
                          // onAction={this.getAuctionByGroupIds.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
const BiddersTable = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="no-bidders">
        <div className="no-bidders-content">
          <span className="no-bidders-icon">
            <FileMinus />
          </span>
          <span>No bidders available</span>
        </div>
      </div>
    );
  }

  const getRankDisplay = (index) => {
    switch (index) {
      case 0:
        return <Trophy className="rank-icon gold" size={16} />;
      case 1:
        return <Medal className="rank-icon silver" size={16} />;
      case 2:
        return <Award className="rank-icon bronze" size={16} />;
      default:
        return <span className="rank-number">{index + 1}</span>;
    }
  };

  return (
    <div className="bidders-wrapper">
      <div className="bidders-header">
        <h6>Bidders Information</h6>
        <span className="bidders-count">
          {data.length} bidder{data.length !== 1 ? 's' : ''}
        </span>
      </div>

      <div className="bidders-table-container">
        <table className="bidders-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Bidder Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Civil ID</th>
              <th>CR Number</th>
              <th>Bid Date</th>
              <th>Bid Amount</th>
            </tr>
          </thead>
          <tbody>
            {data.map((bidder, index) => (
              <tr key={bidder.id} className={bidder.winner === 1 ? 'winner-row' : ''}>
                <td className="rank-cell">{getRankDisplay(index)}</td>
                <td className="bidder-name">
                  <div className="name-container">
                    <span className="name">{bidder.user?.name}</span>
                    {bidder.winner === 1 && <span className="winner-badge">Winner</span>}
                  </div>
                </td>
                <td className="email">{bidder.user?.email}</td>
                <td className="mobile">
                  <span className="country-code">{bidder.user?.country_code}</span>
                  <span className=""> </span>
                  <span className="mobile-number">{bidder.user?.mobile}</span>
                </td>
                <td className="civil-id">{bidder.user?.resident_card_number}</td>
                <td className="cr-number">{bidder.user?.cr_number}</td>
                <td className="bid_date"> {new Date(bidder.created_at).toLocaleString()}</td>
                <td className="max-bid">
                  <span className="amount">{bidder.bid_amount?.toLocaleString()}</span>
                  <span className="currency">SAR</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
